import { unterschiede } from "../dienste/aenderungen.js";
import { fmtZahl, jahrLabel } from "../kern/format.js";
import { TYPEN } from "../kern/konstanten.js";
import { t } from "../i18n/index.js";
import { landName } from "../i18n/laender.js";

/* ================================================================
   Anzeige der Unterschiede zweier Fassungen — gemeinsam für
   „Vorschläge prüfen“, „Meine Vorschläge“ und die Änderungshistorie.
   Die Ermittlung steht in dienste/aenderungen.js; hier wird nur
   formatiert und übersetzt.
   ================================================================ */

function zeigeWert(art, wert, namen) {
  if (wert == null || wert === "") return "—";
  switch (art) {
    case "typ": return TYPEN[wert] ? t(TYPEN[wert].label) : String(wert);
    case "land": return landName(wert);
    case "bezug": return (namen && namen[wert]) || t("unbekannt");
    case "zahl": return fmtZahl(wert, 2);
    case "jahr": return jahrLabel(wert);
    case "rebsorten":
      return (Array.isArray(wert) ? wert : [])
        .map((r) => (r.anteil != null ? `${r.name} ${Math.round(r.anteil)} %` : r.name)).join(", ") || "—";
    case "fenster":
      return `${wert.von != null ? wert.von : "…"}–${wert.bis != null ? wert.bis : "…"}`;
    case "foto": return t("vorhanden");
    default: return String(wert);
  }
}

/* Beschreibungen können lang sein — in der Liste reicht der Anfang. */
const kuerze = (s, n = 90) => (s.length > n ? s.slice(0, n - 1) + "…" : s);

function FeldZeile({ f, namen, konflikt }) {
  const alt = kuerze(zeigeWert(f.art, f.alt, namen));
  const neu = kuerze(zeigeWert(f.art, f.neu, namen));
  return (
    <li className={konflikt ? "ist-konflikt" : ""}>
      <span className="wl-vs-feld">{t(f.label)}</span>
      {f.alt != null && <span className="wl-vs-alt">{alt}</span>}
      {f.alt != null && <span className="wl-vs-pfeil">→</span>}
      <span className="wl-vs-neu">{f.neu == null && f.art === "foto" ? t("entfernt") : neu}</span>
      {konflikt && <span className="wl-vs-konflikt">{t("auch im Katalog geändert")}</span>}
    </li>
  );
}

/** `ausblenden`: Felder, die anderswo schon stehen (etwa der Name im
    Kopf der Zeile). `konfliktFelder`: wie von katalogpflege.js
    geliefert — „beschreibung“ oder „jahrgaenge.2015.trinkVon“. */
function Aenderungen({ vorher, nachher, namen = {}, ausblenden = [], konfliktFelder = [], leerText = null }) {
  const u = unterschiede(vorher, nachher);
  const felder = u.felder.filter((f) => !ausblenden.includes(f.feld));
  const konflikt = new Set(konfliktFelder);
  const jgKonflikt = (jahr, feld) => konfliktFelder.some((k) => {
    if (!k.startsWith(`jahrgaenge.${jahr}.`)) return false;
    const f = k.split(".").pop();
    return feld === "trinkfenster" ? (f === "trinkVon" || f === "trinkBis") : f === feld;
  });

  if (felder.length === 0 && u.jahrgaenge.length === 0) {
    return leerText ? <p className="wl-vs-hinweis">{leerText}</p> : null;
  }
  return (
    <ul className="wl-vs-diff">
      {felder.map((f) => <FeldZeile key={f.feld} f={f} namen={namen} konflikt={konflikt.has(f.feld)} />)}
      {u.jahrgaenge.map((j) => (
        <li key={j.id} className="wl-vs-jg">
          <div className="wl-vs-jgkopf">
            <span className="wl-vs-jgjahr">{jahrLabel(j.jahr)}</span>
            <span className="wl-vs-jgart">
              {j.aenderung === "neu" ? t("neuer Jahrgang") : j.aenderung === "entfernt" ? t("Jahrgang entfernt") : t("geändert")}
            </span>
          </div>
          {j.felder.length > 0 && (
            <ul className="wl-vs-diff wl-vs-jgfelder">
              {j.felder.map((f) => (
                <FeldZeile key={f.feld} f={j.aenderung === "neu" ? { ...f, alt: null } : f}
                  namen={namen} konflikt={jgKonflikt(j.jahr, f.feld)} />
              ))}
            </ul>
          )}
        </li>
      ))}
    </ul>
  );
}

export { Aenderungen };
